



















































































import {
  ref, computed, defineComponent, PropType,
} from '@vue/composition-api';
import { FCCard, FCSelect, FCButton } from '@fc/angie-ui';
import { IBundle } from '~/types/fightcamp';
import FCImage from '~/components/FCImage.vue';
import { isTabletUpEffect } from '~/effects/matchMedia';
import { useModal } from '~/composables/useModal';

export default defineComponent({
  name: 'BundleGroupCard',
  emits: ['bundleAdded'],
  components: {
    FCCard,
    FCImage,
    FCButton,
    FCSelect,
  },
  props: {
    bundle: {
      type: Object as PropType<IBundle>,
      required: true,
      default: () => ({
        img_alt: '',
        img_url: '',
        includes: [],
        item_id: '',
        product: {
          price: '',
          fullPrice: '',
        },
        selects: {
          options: [],
        },
        sold_out: false,
        text: '',
        title: '',
        types: [],
      }),
    },
  },
  setup(props, { emit }) {
    const sizeSelected = ref(null);
    const hasSizeOptions = computed(() => props?.bundle?.selects?.options?.length);
    const sizeSelectorError = ref(false);

    const itemsInBundle = computed(() => {
      if (props?.bundle?.item_id === 'fightcamp_family_bundle') {
        return 'FightCamp 12oz Gloves, FightCamp 16oz Gloves, FightCamp Kid Gloves (2x)';
      }
      return props?.bundle?.includes?.map(item => item.title).join(', ');
    });

    // @ts-ignore
    const { $store } = useNuxtApp();
    const shippingRestricted = computed(() => $store.getters.itemHasShippingRestrictions(props?.bundle?.item_id));

    function triggerAddToCart() {
      if (hasSizeOptions.value) {
        if (sizeSelected.value) {
          sizeSelectorError.value = false;

          addItemToCart();
        } else {
          sizeSelectorError.value = true;
        }
      } else {
        addItemToCart();
      }
    }

    const getCopy = computed(() => (props?.bundle?.sold_out ? 'Sold Out' : 'Add to Cart'));

    const isShopifyOn = computed(() => $store.getters.isShopifyOn);
    async function addItemToCart() {
      if (shippingRestricted.value) return;
      emit('triggerCustomAction');

      const id = sizeSelected.value ?? (isShopifyOn.value ? props?.bundle?.variants[0]?.id : props?.bundle?.item_id);

      await $store.dispatch('insertItemToCart', {
        id,
        type: 'equip',
        disableDrawer: true,
        delay: true,
      });

      $store.commit('ITEM_ADDED');
      emit('bundleAdded');
    }

    function openLightbox() {
      const { modalShow } = useModal({
        component: () => import('./BundleLightBox.vue'),
        componentProps: { bundle: props.bundle },
        modalProps: {
          componentName: 'BundleLightBox',
          classes: 'modal-border-radius',
        },
      });

      modalShow();
    }

    const isTabletUp = isTabletUpEffect();
    const getBgColor = computed(() => (isTabletUp.value ? 'white' : 'eggshell'));
    const getButtonThemeColor = computed(() => ((shippingRestricted.value || props?.bundle?.sold_out) ? 'button-disabled' : 'button-primary'));

    const imgUrl = computed(() => {
      if (props?.bundle?.img_url?.includes('a.storyblok.com')) {
        return {
          provider: 'storyblok',
          url: props.bundle.img_url,
        };
      }

      return {
        provider: 'fcProvider',
        url: props?.bundle?.img_url ?? null,
      };
    });

    const displayPrices = computed(() => {
      if ($store.getters.isShopifyOn) {
        return {
          price: props?.bundle?.price,
          oldPrice: props?.bundle?.oldPrice,
        };
      }

      return {
        price: props?.bundle?.product?.price,
        oldPrice: props?.bundle?.product?.fullPrice,
      };
    });

    return {
      sizeSelected,
      hasSizeOptions,
      sizeSelectorError,
      itemsInBundle,
      openLightbox,
      triggerAddToCart,
      getBgColor,
      getButtonThemeColor,
      shippingRestricted,
      getCopy,
      imgUrl,
      displayPrices,
    };
  },
});
